import React, { useContext } from 'react'
import Select from 'react-select'

import { DBContext } from '../../../contexts/databases'
import { CharacterContext } from '../../../contexts/character'
import { UIContext } from '../../../contexts/ui'

import randomOptionsDict from '../../../data/Items/random_options_dict.json'
import itemOptionsMap from '../../../data/Items/itemOptionsMap.json'

const NONE_OPTION = { value: '', label: 'None' }

function buildSlotChoices(slotOptions) {
	return [
		NONE_OPTION,
		...slotOptions.map(({ id }) => ({
			value: id,
			label: randomOptionsDict[id] ?? id,
		})),
	]
}

function getMinMax(slotOptions, optionId) {
	const found = slotOptions.find((o) => o.id === optionId)
	return found ? { min: found.min, max: found.max } : { min: 0, max: 0 }
}

function buildValueChoices(min, max) {
	const choices = []
	for (let v = min; v <= max; v++) choices.push({ value: v, label: String(v) })
	return choices
}

function OptionSelect({ Location }) {
	const { Item } = useContext(DBContext)
	const { inventory, replaceItemInInventory, maxRefine } =
		useContext(CharacterContext)
	const { customStyles } = useContext(UIContext)

	const current = inventory[Location]
	if (!current || current.AegisName === '0') return null

	const itemDef = itemOptionsMap[current.AegisName]
	if (!itemDef) return null

	const { slots } = itemDef

	function updateOption(slotIndex, field, newValue) {
		const newItem = new Item(Location, maxRefine[Location] > 0)
		newItem.setItem(current)
		newItem.setRefine(current.refine)
		current.CardSlots.forEach((cardSlot, i) =>
			newItem.CardSlots[i].changeSlot(cardSlot),
		)
		newItem.setOptions(current.Options)
		newItem.Options[slotIndex] = {
			...newItem.Options[slotIndex],
			[field]: newValue,
		}
		// Reset value to min when option changes
		if (field === 'optionId') {
			const def = slots[slotIndex]?.options.find((o) => o.id === newValue)
			newItem.Options[slotIndex].value = def?.min ?? 0
		}
		replaceItemInInventory(newItem)
	}

	return (
		<div className='optionSlots'>
			{slots.map((slotDef, i) => {
				const opt = current.Options[i] ?? { optionId: '', value: 0 }
				const choices = buildSlotChoices(slotDef.options)
				const { min, max } = getMinMax(slotDef.options, opt.optionId)
				const valueChoices = buildValueChoices(min, max)
				return (
					<div key={i} className='optionSlot'>
						<Select
							menuPlacement='auto'
							styles={customStyles}
							value={
								choices.find((c) => c.value === opt.optionId) ||
								NONE_OPTION
							}
							options={choices}
							onChange={(event) =>
								updateOption(i, 'optionId', event.value)
							}
						/>
						<Select
							menuPlacement='auto'
							styles={customStyles}
							className='optionValue'
							isDisabled={!opt.optionId}
							value={
								valueChoices.find((c) => c.value === opt.value) ||
								valueChoices[valueChoices.length - 1] ||
								null
							}
							options={valueChoices}
							onChange={(event) =>
								updateOption(i, 'value', event.value)
							}
						/>
					</div>
				)
			})}
		</div>
	)
}

export default OptionSelect
